const YEAR_PREFIXES = /^(?:[~±≈]|circa|ca\.?|c\.?|abt\.?|about|bef\.?|before|aft\.?|after)\s*/i;

function normalizeYear(value) {
    if (value === null || value === undefined || value === '') return null;

    const year = Number(value);
    return Number.isInteger(year) && year > 0 && year <= 9999 ? year : null;
}

/**
 * Extracts a usable calendar year without requiring a complete JavaScript date.
 * TNG represents partial dates as YYYY-00-00 or YYYY-MM-00, neither of which
 * should be passed to the Date constructor.
 */
export function extractEventYear(eventDate, eventYear = null) {
    const explicitYear = normalizeYear(eventYear);
    if (explicitYear !== null) return explicitYear;

    if (eventDate instanceof Date) {
        return Number.isNaN(eventDate.getTime()) ? null : normalizeYear(eventDate.getUTCFullYear());
    }

    if (eventDate === null || eventDate === undefined) return null;

    const dateText = String(eventDate).trim();
    if (!dateText || dateText === '0000-00-00') return null;

    const cleaned = dateText.replace(YEAR_PREFIXES, '').replace(/\?/g, '').trim();
    const leadingYear = cleaned.match(/^(\d{1,4})(?:-|$)/);
    if (leadingYear) {
        return normalizeYear(leadingYear[1]);
    }

    // Preserve support for complete textual dates such as "10 May 1832".
    const parsedDate = new Date(cleaned);
    return Number.isNaN(parsedDate.getTime()) ? null : normalizeYear(parsedDate.getUTCFullYear());
}
